// variantsInsights.js — cleaned up

import React, { useState, useEffect } from 'react';
import { Workflow } from 'lucide-react';
import { getProcessModelTitle } from '@process-advisor/process-miner/processMiner/processMiner';
import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';
import VariantGrid from '@process-advisor/process-miner/dashboard/variants/variantGrid';
import EvidenceHeader from '@process-advisor/process-miner/dashboard/shared/EvidenceHeader';

const VariantInsights = ({ AI, refreshKey, processLabel='Process' }) => {
  const [modelTitle, setModelTitle] = useState('');
  const [variants, setVariants] = useState();
  const [activities, setActivities] = useState();

  useEffect(() => {
    setModelTitle(getProcessModelTitle());
    setActivities(apiProvider.processActivitiesTable());
    setVariants(apiProvider.variantsTable());
  }, [refreshKey]);

  const styles = {
    dashboard: {
      fontFamily:
        '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
      backgroundColor: '#f8f9fa',
      padding: 0
    },
    controls: {
      background: 'linear-gradient(135deg, #FFFFFF 0%, #F7F9FC 100%)',
      padding: '10px 12px',
      marginBottom: 10,
      borderRadius: 10,
      border: '1px solid #DFE1E6',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      flexWrap: 'wrap',
      gap: 8,
      boxShadow: '0 1px 2px rgba(9,30,66,0.06)'
    },
    controlsLeft: { 
      display: 'flex', 
      gap: 8, 
      alignItems: 'center' 
    }
  };

  return (
    <div style={styles.dashboard}>
      <EvidenceHeader
        icon={<Workflow size={18} />}
        title={`${processLabel} Variants`}
        subtitle="Analyse workflow path variations, standardisation risk, and route complexity."
      />

      <VariantGrid variants={variants} activities={activities} />
    </div>
  );
};

export default VariantInsights;